import DefaultLayout from "../../layout/DefaultLayout";
import BreadcrumbTwo from "../../components/Breadcrumbs/BreadcrumbTwo";
import QzTrayPreviewPanel from "../../components/qztray/preview/QzTrayPreviewPanel";

/**
 * 👁️ Página: Previsualización QZ Tray
 */
const QzTrayPreview = () => {
  return (
    <DefaultLayout>
      <BreadcrumbTwo />
        <QzTrayPreviewPanel/>
    </DefaultLayout>
  );
};

export default QzTrayPreview;
